import React, { useEffect, useRef, useState } from 'react';
import ContentfulRichText from 'components/RichText/ContentfulRichText';

import { Container } from './styles';

const Copy = ({ handleCopyHover, slideInfo, slideshowStarted, handleItemClick, items }) => {
  const containerRef = useRef();
  const [copyContainerHeight, setCopyContainerHeight] = useState(null);
  const [tallestContainer, setTallestContainer] = useState(null);
  const [itemHover, setItemHover] = useState({ index: null, hover: false });

  const setContainerHeight = () => {
    const copyContainer = containerRef?.current?.querySelector('.copy-container');
    if (copyContainer) {
      copyContainer.style.height = 'auto';
      const tallestContainerHeight = copyContainer.clientHeight;
      copyContainer.style.height = `${tallestContainerHeight}px`;
      setTallestContainer(tallestContainerHeight);
    }
  };

  useEffect(() => {
    if (slideshowStarted) {
      setContainerHeight();
    }
  }, [slideshowStarted]);

  useEffect(() => {
    if (tallestContainer) {
      setCopyContainerHeight(tallestContainer);
    }
  }, [tallestContainer]);

  useEffect(() => {
    const handleWindowResize = () => setContainerHeight();

    window.addEventListener('resize', handleWindowResize);

    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);

  useEffect(() => {
    const indexes = [0, 1, 2];
    const inactiveIndexes = indexes.filter((index) => index !== slideInfo.index);

    inactiveIndexes.forEach((index) => {
      const inactiveElem = containerRef?.current?.querySelector(`.myBar-${index}`);
      if (inactiveElem) {
        inactiveElem.style.height = '0%';
      }
    });
    const activeElem = containerRef?.current?.querySelector(`.myBar-${slideInfo.index}`);
    if (activeElem) {
      activeElem.style.height = `${slideInfo.timer}%`;
    }
  }, [slideInfo, containerRef]);

  return (
    <Container
      ref={containerRef}
      timer={slideInfo.timer}
      copyContainerHeight={copyContainerHeight}
      itemHover={itemHover}
      className="copy-container"
    >
      <div className="copy--all-copy-container">
        {items?.map((item, index) => {
          return (
            <div
              key={`copy-container-${index}`}
              className={`copy--copy-container ${
                slideInfo.index === index ? 'active' : 'inactive'
              } ${slideInfo.completedOnce ? 'initial-complete' : ''} ${
                index === 0
                  ? 'first'
                  : index === items.length - 1
                  ? 'last no-exit-transition'
                  : 'no-exit-transition'
              }
            `}
              onMouseEnter={() => slideInfo.index === index && handleCopyHover(true)}
              onMouseLeave={() => slideInfo.index === index && handleCopyHover(false)}
            >
              <div
                className="myProgress"
                style={{
                  background:
                    itemHover.index === index && itemHover.hover && slideInfo.index !== index
                      ? 'var(--titan-blue-3)'
                      : '#eee',
                }}
              >
                <div
                  className={`myBar myBar-${index} ${
                    slideInfo.index === index ? 'active' : 'inactive'
                  }`}
                ></div>
              </div>
              <div className="copy--copy">
                <h4
                  className={`copy--copy-title ${
                    itemHover.index === index && itemHover.hover ? 'hovered' : ''
                  }`}
                  onClick={() => {
                    handleItemClick(index);
                    setItemHover({ index, hover: false });
                  }}
                  onMouseEnter={() => setItemHover({ index, hover: true })}
                  onMouseLeave={() => setItemHover({ index, hover: false })}
                >
                  {item.title}
                </h4>
                <div className="copy--copy-rich-text">
                  <ContentfulRichText
                    richText={{
                      content: item?.description,
                      listIcon: item?.icon?.image?.file?.url,
                    }}
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </Container>
  );
};

export default Copy;
